<template>
    <div class="top-menu">
        <div class="flex-container">
            <div class="flex-child" role="group">
                <ul style="list-style-type: none; padding: 0;">
                    <li v-for="(i, idx) in whitlam" :key="idx"><a :href="currentEnv.serverUrl+'/bookingapp/whitlam-calendar?page='+i.href">
                        <button class="btn btn-txt grow"
                            style="background-color: rgb(213, 100, 28);">{{ i.venueName }}</button>
                    </a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { WHITLAM } from '../data.js';
import { Envs } from '../../../../config';
export default {
    data() {
        return {
            whitlam: WHITLAM,
            currentEnv: '',
            mytk: '',
            currentRoute: '',
        }
    },

    beforeMount() {
    this.currentEnv = Envs;
    this.mytk = this.currentEnv.tokenUrl;
    this.currentRoute = this.$router.currentRoute;
  },
}
</script>

<style>
ul {
  list-style-type: none;
  display: block;
}

li {
    cursor: pointer;
}

.btn {
  border: none;
  border-radius: 0px;
  color: #fff;
  width: 50rem;
}

.form-control {
  margin: 1rem 0;
}

.btn-txt {
  font-weight: bold;
  /* display: block; */
  /* font-family: inherit; */
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.grow {
  -webkit-transition: height 500ms;
  -moz-transition: height 500ms;
  transition: height 500ms;
}
.btn:hover .grow {
  width: 20%;
}
.btn:hover .grow:hover {
  width: 40%;
}

@media (max-width: 768px) {
  .btn {
    font-size: 1rem;
    width: 100%;
    height: auto;
  }
}
</style>